<template>
  <sweet-modal ref="bookingCalendarModal" width="600px" :title="$t('ct-options')">
    <div v-if="calendars.length > 0" :key="key">

      <!-- Calendars -->
      <div class="form-group col-md-12 mb-4">
        <label> {{ $t('ct-select-calendar') }}</label>
        <select v-model="options.calendar" class="form-control">
          <option v-for="(calendar, index) in calendars"
                  :key="index"
                  :value="index"
                  v-text="calendar.title"
          />
        </select>
      </div>

      <!-- Redirecionamento após o agendamento -->
      <div class="form-group col-md-12 mb-4">
        <label>{{ $t('ct-redir-after-scheduling') }}</label>
        <div>
          <button
            class="ba7-switch-btn" 
            :class="{'active-switch': options.typeRedir == 'page'}"
            @click="defineNewType('page')"
          >{{ $t('ct-link-page-editor')}}</button>
          <button 
            class="ba7-switch-btn" 
            :class="{'active-switch': options.typeRedir == 'web'}"
            @click="defineNewType('web')"
          >{{ $t('ct-link-page-web')}}</button>
        </div>
        <br>
        <select v-if="options.typeRedir == 'page'" v-model="options.forceRedir" class="form-control">
          <option value="" v-text="$t('ct-booking-standard')" />
          <option v-for="(p, index) in pages" :key="index" :value="p.id" v-text="p.title" />
        </select>
        <input v-else type="url" v-model="options.forceRedir" class="form-control">
      </div>

      <!-- Show info -->
      <div class="form-group col-md-12 mb-4">
        <label>{{ $t('ct-show-info') }}</label>
        <div class="row d-flex">
          <div class="form-check">
            <input
              id="show_info_yes"
              type="radio"
              class="form-check-input"
              v-model="options.showInfo"
              :value="true"
            >
            <label class="form-check-label" for="show_info_yes">
              {{ $t('ct-yes') }}
            </label>
          </div>
          <div class="form-check ml-3">
            <input
              id="show_info_no"
              type="radio"
              class="form-check-input"
              v-model="options.showInfo"
              :value="false"
            >
            <label class="form-check-label" for="show_info_no">
              {{ $t('ct-no') }}
            </label>
          </div>
        </div>
      </div>

      <!-- Show calendar -->
      <div
        v-if="!!calendars.length && showEvents !== 3 && showEvents !== 4"
        class="form-group col-md-12 mb-4">
        <label>{{ $t('ct-show') }}</label>
        <div class="row d-flex">
          <div class="form-check">
            <input
              id="show_all_calendar"
              type="radio"
              class="form-check-input"
              v-model="options.showGroup"
              :value="false"
            >
            <label class="form-check-label" for="show_all_calendar">
              {{ $t('ct-calendar-all') }}
            </label>
          </div>
          <div class="form-check ml-3">
            <input
              id="show_group_specific"
              type="radio"
              class="form-check-input"
              v-model="options.showGroup"
              :value="true"
            >
            <label class="form-check-label" for="show_group_specific">
              {{ $t('ct-calendar-group-specific') }}
            </label>
          </div>
        </div>
      </div>

      <!-- Group -->
      <div
        v-if="calendars.length > 0 && options.showGroup && showEvents !== 3 && showEvents !== 4"
        class="form-group col-md-10 mb-5">
        <label> {{ $t('ct-select-group') }}</label>
        <select
          v-model="options.group"
          class="form-control"
        >
          <option
            v-for="group in calendars[options.calendar].classes"
            :key="group.slug"
            :value="group.slug"
            v-text="group.title"
          />
        </select>
      </div>
    </div>

    <!-- Redirecionamento após o agendamento - mostra quando tem um link do booking que não seja de algum dos meus calendários, sempre de cópia de outro user, booking continua referenciando o calendário do pai, então conseguimos alterar o force redir -->
    <div v-else-if="!options.src == false">
      <div class="form-group col-md-12 mb-4">
        <label>{{ $t('ct-redir-after-scheduling') }}</label>
        <div>
          <button
            class="ba7-switch-btn" 
            :class="{'active-switch': options.typeRedir == 'page'}"
            @click="defineNewType('page')"
          >{{ $t('ct-link-page-editor')}}</button>
          <button 
            class="ba7-switch-btn" 
            :class="{'active-switch': options.typeRedir == 'web'}"
            @click="defineNewType('web')"
          >{{ $t('ct-link-page-web')}}</button>
        </div>
        <br>
        <select v-if="options.typeRedir == 'page'" v-model="options.forceRedir" class="form-control">
          <option value="" v-text="$t('ct-booking-standard')" />
          <option v-for="(p, index) in pages" :key="index" :value="p.id" v-text="p.title" />
        </select>
        <input v-else type="url" v-model="options.forceRedir" class="form-control">
      </div>
    </div>

    <!-- None calendars -->
    <div :key="key" v-else>
      <h6>{{ $t('ct-booking-have-create') }}<a :href="getUrlBooking()" target="_blank">{{ $t('ct-booking-app') }}</a></h6>
    </div>

    <!-- Buttons modal -->
    <div class="footer-buttons">
      <a
        v-if="calendars.length === 0"
        slot="button"
        class="btn btn-primary m-0"
        :href="getUrlBooking()"
        target="_blank"
      >{{ $t('ct-booking-create') }}</a>
      <button
        slot="button"
        class="btn btn-outline-light m-0"
        @click="$refs.bookingCalendarModal.close()"
      >{{ $t('ct-cancel') }}
      </button>
      <button
        slot="button"
        class="btn btn-success focus"
        @click="save"
      ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
      </button>
    </div>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import {getBit} from '../../../../../js/services/editor/page';
import {getCalendar} from '../../../../../js/services/integrations-internas/booking';

export default {
  name: 'BookingCalendarModal',
  components: {
    SweetModal
  },
  props: ['config'],
  data() {
    return {
      key: 1,
      options: {
        calendar: 0,
        showInfo: false,
        showGroup: false,
        forceRedir: '',
        typeRedir: 'page',
        group: 0,
        src: ''
      },
      showEvents: 0,
      calendars: false,
      message: false,
      callback: false,
      pages: null,
    };
  },
  computed: {
    calendar() {
      return this.options.calendar;
    }
  },
  watch: {
    calendar(val) {
      if (this.calendars[val]) {
        this.showEvents = this.calendars[val].type;
      }
    }
  },
  created(){
    this.getPages();
  },
  methods: {
    defineNewType(data){
      this.options.typeRedir = data;
      this.options.forceRedir = '';
    },
    save() {
      const { calendar, showInfo, showGroup, group, forceRedir } = this.options;

      if(this.calendars[calendar]){
        let { url } = this.calendars[calendar];
        url += showGroup ? `/${group}` : '';
        url += `?show_event_infos=${showInfo}`;
        url += `&force_redir=${forceRedir}`;
  
        this.callback({
          ...this.options,
          src: url
        });
      } else {
        // Salva apenas o forceRedir
        let url = new URL(this.options.src);
        url.searchParams.set('force_redir', forceRedir);

        this.callback({
          ...this.options,
          src: url.toString()
        });
      }
      this.$refs.bookingCalendarModal.close();
    },
    getUrlBooking() {
      const officeDomain = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : 'https://office.builderall.com';
      return `${officeDomain}/br/office/booking`;
    },
    forceUpdate() {
      this.key += 1;
    },
    getPages(){
      getBit(this.$route.params.page_id)
        .then(async response => {
          if (response.data) {
            this.pages = response.data.layout.pages;
          }
        })
    },
    async getUserCalendars() {
      const { id_office_user } = this.$store.state.user;

      await getCalendar(id_office_user)
        .then(({ data }) => {
          if (data.length > 0) {
            if (this.options.calendar) {
              this.showEvents = data[this.options.calendar].type;
            }

            var calendars = data;
            this.calendars = false;
            this.calendars = calendars;

          } else {
            this.message = true;
          }
        })
        .catch(error => this.message = true);

      this.forceUpdate();
    },
    init(config, callback = false) {
      this.options = config;
      this.callback = callback;
    },
    open(modal) {
      if (this.$refs[modal]) {
        this.$refs[modal].open();
        this.getUserCalendars();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  h6 {
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 26px;
    height: 120px;

    a {
      margin-left: 10px;
    }
  }

  .form-group {
      .row {
        margin: 0;
      }
    }

  .footer-buttons{
    display: block;
    text-align: right;

    .btn {
      &:first-child{
        float: left;
      }
    }
  }

  .ba7-switch-btn{
    background: transparent;
    border: none;
    outline: none;
    color: #007bff;
    border-radius: .25rem;
    padding: .5rem 1rem;
    &.active-switch{
      background-color: #007bff;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Booking/Calendar/ConfigModals.vue